/**
 * HUB-C — Onglets sections paiements (timeline, SumUp, Stripe, pending, preuves, retraits).
 */
import React from 'react';
import { PAIEMENTS_SECTIONS } from '../../utils/paiements/paiementsDisplay';

const SECTIONS = [
  { id: PAIEMENTS_SECTIONS.TIMELINE, label: 'Timeline' },
  { id: PAIEMENTS_SECTIONS.SUMUP, label: 'SumUp' },
  { id: PAIEMENTS_SECTIONS.STRIPE, label: 'Stripe' },
  { id: PAIEMENTS_SECTIONS.PENDING, label: 'En attente' },
  { id: PAIEMENTS_SECTIONS.PROOFS, label: 'Preuves' },
  { id: PAIEMENTS_SECTIONS.RETRAITS, label: 'Retraits' },
];

export default function ActivitePaiementsSectionTabs({ activeSection, onSectionChange, counts = {} }) {
  return (
    <div className="flex gap-2 flex-wrap" data-testid="activite-paiements-section-tabs">
      {SECTIONS.map((section) => {
        const isActive = activeSection === section.id;
        const count = counts[section.id];
        return (
          <button
            key={section.id}
            type="button"
            onClick={() => onSectionChange(section.id)}
            className={`px-4 py-2.5 min-h-[44px] rounded-xl text-sm font-semibold transition-all border ${
              isActive
                ? 'text-[var(--rm-white)]'
                : 'text-[var(--rm-gray-400)] hover:text-[var(--rm-gray-200)]'
            }`}
            style={{
              borderColor: isActive ? 'var(--rm-border-strong)' : 'var(--rm-border-subtle)',
              background: isActive ? 'var(--rm-bg-panel)' : 'transparent',
            }}
            data-testid={`activite-paiements-section-${section.id}`}
          >
            {section.label}
            {count != null && count > 0 && (
              <span className="ml-1.5 px-1.5 py-0.5 rounded-full text-xs rm-badge rm-badge--muted">
                {count}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}
